var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var f0 = _vm.postDetail
    ? _vm._f("formatDateTime")(_vm.postDetail.createTime)
    : null
  var f1 = _vm.postDetail
    ? _vm._f("formatRichText")(_vm.postDetail.content.content)
    : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        f0: f0,
        f1: f1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }